import React, { useContext, useEffect, useState } from 'react'
import { Redirect, useHistory } from 'react-router-dom'
import { signoutRedirectCallback } from '../services/UserService'
import { store } from '../store';

const SignOut = () => {
    const [isDataLoaded, setIsDataLoaded] = useState(false)
    const globalState = useContext(store);
    const { dispatch } = globalState;

    useEffect(() => {
        signoutRedirectCallback()
            .then(() => dispatch({ type: "unset admin status" }))
            .then(() => setIsDataLoaded(true))
            .catch(() =>
                <Redirect to="/" />);
    }, [])

    return (
        <React.Fragment>
            {isDataLoaded &&
                <Redirect to="/" />
                || <div> Signing out....
                </div>
            }
        </React.Fragment>
    )
}

export default SignOut